export type ReviewRating = 'again' | 'hard' | 'good' | 'easy'
export type MasteryLevel = 'new' | 'learning' | 'review' | 'mastered'

export interface SRSInput {
  rating: ReviewRating
  currentEaseFactor: number
  currentIntervalDays: number
  currentRepetitions: number
  currentMasteryLevel: MasteryLevel
}

export interface SRSResult {
  easeFactor: number
  intervalDays: number
  repetitions: number
  masteryLevel: MasteryLevel
}

function ratingToQuality(rating: ReviewRating): number {
  switch (rating) {
    case 'again':
      return 0
    case 'hard':
      return 3
    case 'good':
      return 4
    case 'easy':
      return 5
    default:
      return 3
  }
}

function calculateEaseFactor(currentEF: number, quality: number): number {
  return Math.max(1.3, currentEF + (0.1 - (5 - quality) * (0.08 + (5 - quality) * 0.02)))
}

function determineMasteryLevel(intervalDays: number, repetitions: number): MasteryLevel {
  if (repetitions === 0 || intervalDays === 0) return 'new'
  if (intervalDays <= 6) return 'learning'
  if (intervalDays <= 21) return 'review'
  return 'mastered'
}

export function calculateNextReview(input: SRSInput): SRSResult {
  const quality = ratingToQuality(input.rating)
  const newEF = calculateEaseFactor(input.currentEaseFactor, quality)

  let interval: number
  let reps: number

  if (quality < 3) {
    interval = 1
    reps = 0
  } else {
    reps = input.currentRepetitions + 1
    if (reps === 1) interval = 1
    else if (reps === 2) interval = 6
    else interval = Math.round(input.currentIntervalDays * newEF)
  }

  return {
    easeFactor: newEF,
    intervalDays: interval,
    repetitions: reps,
    masteryLevel: determineMasteryLevel(interval, reps),
  }
}

export function calculateNextReviewDate(intervalDays: number): string {
  const now = new Date()
  const local = new Date(now.getTime())
  local.setDate(local.getDate() + intervalDays)
  const tz = local.getTimezoneOffset() * 60 * 1000
  const adj = new Date(local.getTime() - tz)
  return adj.toISOString().split('T')[0]
}

